import { COOKIES_BANNER_WAS_CLOSED as localStorageKey } from '../KEYS';

export default {
  get(): boolean {
    return localStorage.getItem(localStorageKey) === JSON.stringify(true);
  },

  set() {
    localStorage.setItem(localStorageKey, JSON.stringify(true));
  },
};
